// loadUrlPopup.js
'use strict';
import addModal from '../action/addModal.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const selectPath = ['urlPopup'];

/**
 * Load url popup
 * @kind action
 * @param {URL} {url} - action param.
 * @return {Promise} Action promise.
 */
const loadUrlPopup =
  ({ url }) =>
  async dispatch => {
    const imageSrc = url.searchParams.get('popup_img');
    const actionUrl = url.searchParams.get('popup_action');

    if (!imageSrc || !actionUrl || '/' !== actionUrl[0]) {
      return { type: '' };
    }

    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath,
        data: { imageSrc, actionUrl },
      },
    });

    return dispatch(
      addModal({
        id: 'GeneralUrlPopup',
        isHigherThanAll: true,
      })
    );
  };

export default loadUrlPopup;
